/* ==========================================================================
   LATIGO ATELIER — shared behaviour

   The bag talks to Shopify's Cart AJAX API and the drawer is re-rendered by
   the Section Rendering API, so quantities, line prices and the subtotal are
   whatever Shopify says they are. The product page resolves the chosen size
   and colour to a variant id before anything is added.
   ========================================================================== */
(function () {
  'use strict';

  var CART_SECTION = 'cart-drawer';

  /* ---------- preloader ---------- */
  window.addEventListener('load', function () {
    var l = document.getElementById('loader');
    if (l) setTimeout(function () { l.classList.add('done'); }, 620);
  });

  /* ---------- nav ---------- */
  var nav = document.querySelector('.nav');
  var last = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (!nav) return;
    nav.classList.toggle('solid', y > 40);
    nav.classList.toggle('hide', y > 320 && y > last && !document.body.classList.contains('no-scroll'));
    last = y;
  }, { passive: true });

  /* ---------- mobile menu ---------- */
  function bindMenu() {
    var burger = document.querySelector('.burger');
    var menu = document.querySelector('.mobile-menu');
    if (!burger || !menu || burger.dataset.bound) return;
    burger.dataset.bound = '1';
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('no-scroll', open);
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  /* ---------- scroll reveal ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function observeReveals(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.in), .clip-reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- region picker ---------- */
  var narrow = function () { return window.matchMedia('(max-width:860px)').matches; };

  function labelRegionPickers() {
    var compact = narrow();
    document.querySelectorAll('.region-select').forEach(function (sel) {
      if (sel.dataset.compact === String(compact)) return;
      sel.dataset.compact = String(compact);
      Array.prototype.forEach.call(sel.options, function (opt) {
        var next = compact ? opt.dataset.compact : opt.dataset.full;
        if (next) opt.textContent = next;
      });
      if (!sel.dataset.bound) {
        sel.dataset.bound = '1';
        sel.addEventListener('change', function () {
          if (sel.form) sel.form.submit();
        });
      }
    });
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(labelRegionPickers, 150);
  }, { passive: true });

  /* ---------- toast ---------- */
  var toastEl = document.querySelector('.toast');
  var toastT;
  function toast(msg) {
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2200);
  }

  /* ---------- drawer ---------- */
  var scrim = document.querySelector('.scrim');
  function drawerEl() { return document.querySelector('.drawer'); }

  function open() {
    var d = drawerEl();
    if (!d) return;
    d.classList.add('on');
    if (scrim) scrim.classList.add('on');
    document.body.classList.add('no-scroll');
  }
  function close() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('on');
    if (scrim) scrim.classList.remove('on');
    document.body.classList.remove('no-scroll');
  }

  function paintCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('on', count > 0);
    });
  }

  function applySection(html, keepOpen) {
    var host = document.getElementById('shopify-section-' + CART_SECTION);
    if (!host || !html) return;
    host.innerHTML = html;
    var d = drawerEl();
    if (d) {
      paintCount(parseInt(d.dataset.itemCount, 10) || 0);
      if (keepOpen) open();
    }
  }

  function sectionFrom(data) {
    if (data && data.sections && data.sections[CART_SECTION]) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = data.sections[CART_SECTION];
      var inner = wrapper.querySelector('#shopify-section-' + CART_SECTION);
      return inner ? inner.innerHTML : wrapper.innerHTML;
    }
    return null;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  var busy = false;

  /* Takes one variant id and a quantity, or an array of { id, quantity }
     lines, so an add-on can go into the bag with the main product. */
  function addToCart(id, quantity) {
    if (busy) return;
    busy = true;
    var items = Array.isArray(id) ? id : [{ id: id, quantity: quantity }];
    post(window.Latigo.routes.cart_add, { items: items, sections: CART_SECTION })
      .then(function (data) {
        applySection(sectionFrom(data), true);
        open();
        toast(window.Latigo.strings.added);
      })
      .catch(function (err) {
        toast((err && err.description) || window.Latigo.strings.error);
      })
      .then(function () { busy = false; });
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    var wasOpen = !!(drawerEl() && drawerEl().classList.contains('on'));
    post(window.Latigo.routes.cart_change, { id: key, quantity: quantity, sections: CART_SECTION })
      .then(function (data) {
        applySection(sectionFrom(data), wasOpen);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { toast(window.Latigo.strings.error); })
      .then(function () { busy = false; });
  }

  function lineQty(key) {
    var line = document.querySelector('.line[data-key="' + key + '"] .qty span');
    return line ? parseInt(line.textContent, 10) || 0 : 0;
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-btn')) { e.preventDefault(); open(); return; }
    if (e.target.closest('.drawer-close') || e.target.closest('.scrim')) { close(); return; }

    var rm = e.target.closest('[data-rm]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-rm'), 0); return; }

    var bp = e.target.closest('[data-bump]');
    if (bp) {
      e.preventDefault();
      var key = bp.getAttribute('data-key');
      var next = lineQty(key) + parseInt(bp.getAttribute('data-bump'), 10);
      changeLine(key, Math.max(0, next));
      return;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- product form ---------- */
  function bindProductForm() {
    var form = document.getElementById('pdp-form');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';

    var val = form.querySelector('[data-qty-val]');
    var hidden = form.querySelector('[data-qty-input]');
    var plus = form.querySelector('#plus');
    var minus = form.querySelector('#minus');

    function setQty(n) {
      n = Math.max(1, n);
      if (val) val.textContent = n;
      if (hidden) hidden.value = n;
    }
    if (plus) plus.addEventListener('click', function () { setQty((+val.textContent) + 1); });
    if (minus) minus.addEventListener('click', function () { setQty((+val.textContent) - 1); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      if (btn && btn.disabled) return;
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      var items = [{ id: id.value, quantity: parseInt(hidden ? hidden.value : 1, 10) || 1 }];
      form.querySelectorAll('[data-extra]').forEach(function (x) {
        var q = parseInt(x.getAttribute('data-extra-qty'), 10) || 0;
        if (x.value && q > 0) items.push({ id: x.value, quantity: q });
      });
      addToCart(items);
    });
  }

  /* ---------- variant picker ----------
     Each option with more than one value is a fieldset of radios; options
     with a single value travel as a hidden input. Together they resolve to
     exactly one variant, whose id goes into the form. */
  function bindVariants() {
    var form = document.getElementById('pdp-form');
    var dataEl = document.querySelector('[data-variants]');
    if (!form || !dataEl || form.dataset.variantsBound) return;
    form.dataset.variantsBound = '1';

    var variants = [];
    var prices = {};
    try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
    var pricesEl = document.querySelector('[data-variant-prices]');
    if (pricesEl) { try { prices = JSON.parse(pricesEl.textContent) || {}; } catch (e) { prices = {}; } }
    // A product with a single default variant has no options to resolve;
    // the server-rendered id, price and button are already right.
    if (variants.length < 2) return;

    var idInput = form.querySelector('[data-variant-id]');
    var btn = form.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-price]');
    var count = variants[0].options.length;
    var s = window.Latigo.strings || {};

    function chosen() {
      var out = [];
      for (var i = 0; i < count; i++) {
        var checked = form.querySelector('[data-option-index="' + i + '"] input:checked');
        var fixed = form.querySelector('[data-fixed-option="' + i + '"]');
        out.push(checked ? checked.value : (fixed ? fixed.value : null));
      }
      return out;
    }

    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < count; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function update(fromUser) {
      var opts = chosen();
      var v = find(opts);

      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-opt-label]');
        if (label) label.textContent = checked ? checked.value : '';
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice();
          test[idx] = inp.value;
          var tv = find(test);
          inp.parentNode.classList.toggle('is-out', !tv || !tv.available);
        });
      });

      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = s.unavailable || 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = v.id;
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (s.add || 'Add to bag') : (s.sold_out || 'Sold out');
      }
      var pr = prices[String(v.id)];
      if (priceEl && pr) priceEl.innerHTML = pr.p + (pr.c ? ' <s>' + pr.c + '</s>' : '');

      if (fromUser) {
        if (v.featured_media && v.featured_media.id) {
          var thumb = document.querySelector('#thumbs [data-media-id="' + v.featured_media.id + '"]');
          if (thumb && !thumb.classList.contains('on')) thumb.click();
        }
        if (window.history && history.replaceState) {
          history.replaceState(null, '', window.location.pathname + '?variant=' + v.id);
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update(true);
    });
    update(false);
  }

  /* ---------- product gallery ---------- */
  function bindGallery() {
    var thumbs = document.getElementById('thumbs');
    var mainBox = document.getElementById('main');
    if (!mainBox || mainBox.dataset.bound) return;
    mainBox.dataset.bound = '1';

    /* Photos swap into the main <img>; videos play muted in a <video> that
       sits in the same box, and the two hide each other. */
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var img = mainBox.querySelector('img');
        var vid = mainBox.querySelector('video');
        var src = b.getAttribute('data-video');
        if (src) {
          if (!vid) {
            vid = document.createElement('video');
            vid.muted = true; vid.loop = true; vid.autoplay = true; vid.playsInline = true;
            vid.setAttribute('playsinline', '');
            mainBox.appendChild(vid);
          }
          vid.poster = b.getAttribute('data-src');
          vid.src = src;
          vid.hidden = false;
          if (img) img.hidden = true;
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
          return;
        }
        if (vid) { vid.pause(); vid.hidden = true; }
        if (!img) {
          img = document.createElement('img');
          img.alt = '';
          mainBox.appendChild(img);
        }
        img.hidden = false;
        img.alt = b.getAttribute('aria-label') || '';
        img.style.opacity = 0;
        setTimeout(function () {
          img.removeAttribute('srcset');
          img.src = b.getAttribute('data-src');
          img.style.opacity = 1;
        }, 200);
      });
    }
    mainBox.addEventListener('mouseenter', function () { mainBox.classList.add('zoom'); });
    mainBox.addEventListener('mouseleave', function () { mainBox.classList.remove('zoom'); });
  }

  /* ---------- boot ---------- */
  function init(root) {
    bindMenu();
    labelRegionPickers();
    bindProductForm();
    bindVariants();
    bindGallery();
    observeReveals(root);
  }

  init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.latigoCart = { add: addToCart, open: open, close: close };
})();
